// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"93":"list","767":"details","818":"auth","845":"profile","922":"edit"}[chunkId] || chunkId) + "." + {"93":"80e0eaf9","326":"65d7ff2d","334":"5892c85f","767":"70f022e4","818":"3b8e6f18","845":"bd0fc0c5","922":"a8fb242f"}[chunkId] + ".js";
};